<template>
  <div class="row">
    <div class="col-6">
      <idx-card
        :title="`${this.$t('menu.settings.hierarchies.titleNewBranch')}`"
        icon="building"
      >
        <div class="form-group">
          <label for="filial"
            >{{ $t('menu.settings.hierarchies.labels.nameBranch') }}:
          </label>
          <input
            type="text"
            class="form-control"
            v-model="filial"
            id="filial"
            :placeholder="`${$t(
              'menu.settings.hierarchies.placeholderNameBranch',
            )}`"
          />
          <div class="invalid-feedback">
            {{ $t('menu.settings.hierarchies.feedbackInformBranch') }}
          </div>
        </div>
        <div class="form-group">
          <label for="descricao"
            >{{ $t('menu.settings.hierarchies.labels.description') }}:
          </label>
          <input
            type="text"
            class="form-control"
            v-model="description"
            id="descricao"
            :placeholder="`${$t(
              'menu.settings.hierarchies.placeholderEnterDescription',
            )}`"
          />
        </div>
        <div class="form-group">
          <label for="group"
            >{{ $t('menu.settings.hierarchies.labels.group') }}:
          </label>
          <input
            type="text"
            class="form-control"
            v-model="group"
            id="group"
            :placeholder="`${$t(
              'menu.settings.hierarchies.placeholderEnterGroup',
            )}`"
          />
        </div>
        <div class="form-group">
          <label for="codigo"
            >{{ $t('menu.settings.hierarchies.labels.code') }}:
          </label>
          <input
            type="text"
            class="form-control"
            v-model="code"
            id="codigo"
            :placeholder="`${$t(
              'menu.settings.hierarchies.placeholderEnterCode',
            )}`"
          />
        </div>
        <div v-for="(branch, i) in branches" :key="i">
          <div class="row custom mt-4 mb-4">
            <div class="col-4">
              <input
                type="text"
                class="form-control"
                id="customLabel"
                :placeholder="`${$t(
                  'menu.settings.hierarchies.placeholderCustomField',
                )}`"
              />
            </div>
            <div class="col-8">
              <input
                type="text"
                class="form-control"
                id="customInput"
                :placeholder="`${$t(
                  'menu.settings.hierarchies.placeholderValue',
                )}`"
              />
            </div>
          </div>
        </div>
        <div class="btn-div">
          <div>
            <button class="btn btn-trash" @click="removeGroup()">
              <div class="mask"></div>
              <font-awesome-icon :icon="['fas', 'trash-alt']" />
            </button>
            <button class="btn btn-add ml-1" @click="addGroup">
              <font-awesome-icon :icon="['fas', 'plus']" />
            </button>
          </div>
          <button @click="submitBranch" class="btn btn-primary">
            {{ $t('menu.settings.hierarchies.buttonRegister') }}
          </button>
        </div>
      </idx-card>
    </div>
    <div class="col-6">
      <div class="col-6 p-0 mb-3">
        <div class="search-users">
          <input
            type="text"
            id="filter-filial"
            v-model="filter"
            @keyup="handleFilter"
            class="form-control"
            :placeholder="`${$t(
              'menu.settings.hierarchies.placeholderSearch',
            )}`"
          />

          <button
            @click="cleanFilter"
            class="btn btn-outline-primary"
            :title="`${'menu.settings.hierarchies.clear'}`"
          >
            {{ $t('menu.settings.hierarchies.clear') }}
          </button>
        </div>
      </div>
      <b-table striped :items="ih1.branches" :fields="fields" :busy="loading">
        <template v-slot:table-busy>
          <div class="text-center text-primary my-2">
            <b-spinner type="grow" class="align-middle"></b-spinner>
          </div>
        </template>
        <template v-slot:cell(createdAt)="row">
          {{ formatDate(row.item.createdAt) }}
        </template>
        <template v-slot:cell(options)="row">
          <button
            v-b-modal="`edit-branch-${row.item._id}`"
            class="btn btn-outline-primary"
          >
            <font-awesome-icon :icon="['fas', 'pen']" />
          </button>
          <button
            @click="removeBranch(row.item._id)"
            class="btn btn-outline-danger"
          >
            <font-awesome-icon :icon="['fas', 'trash-alt']" />
          </button>
          <modal-edit-branch
            :id="row.item._id"
            :corporate_name="row.item.corporate_name"
            :description="row.item.description"
            :group="row.item.group"
            :code="row.item.code"
            :secondary_fields="row.item.secondary_fields ? row.item.secondary_fields : []"
            :type="row.item.type"
            :page="currentPage"
          />
        </template>
      </b-table>
      <div class="pagination-area-ih1">
        <paginate
          v-model="currentPage"
          :pageCount="Math.ceil(ih1.total / 10)"
          :clickHandler="handleBranches"
          :prevText="'‹'"
          :nextText="'›'"
          :activeClass="'active'"
          :containerClass="'pagination b-pagination'"
          :pageClass="'page-item'"
        >
        </paginate>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import swal from 'sweetalert';
import Paginate from 'vuejs-paginate';
import { format } from 'date-fns';
import pt from 'date-fns/locale/pt';
import IdxCard from '@/components/molecules/idx-card';
import modalEditBranch from './modal-edit-branch';

export default {
  name: 'branches',

  data() {
    return {
      filial: '',
      description: null,
      group: null,
      code: null,
      customField: [],
      branches: [],
      userAuth: null,
      errors: null,
      fields: [],
      loading: true,
      currentPage: 1,
      filter: null,
    };
  },

  components: {
    modalEditBranch,
    Paginate,
    IdxCard,
  },

  computed: {
    ...mapFields('branches', ['ih1']),
  },

  methods: {
    ...mapActions('branches', [
      'addBranch',
      'getBranchesIH1',
      'deleteBranch',
      'listBranchesIh1',
    ]),

    async handleBranches() {
      this.loading = true;
      await this.getBranchesIH1({
        companyId: JSON.parse(localStorage.getItem('_indecx')).companyId,
        token: JSON.parse(localStorage.getItem('_indecx')).token,
        page: this.currentPage,
        limit: 10,
        filter: this.filter,
      });
      this.loading = false;
    },

    cleanFilter() {
      this.filter = null;
      this.handleBranches();
    },

    handleFilter() {
      if (this.filter !== '' && this.filter !== null) {
        clearTimeout(this.typingTimer);
        this.typingTimer = setTimeout(this.handleBranches, 600);
      }

      if (this.filter === '') {
        this.filter = null;
        this.page = 1;
        this.handleBranches();
      }
    },

    formatDate(param) {
      const date = format(new Date(param), 'dd/MM/yyyy', { locale: pt });
      return date;
    },

    async submitBranch() {
      if (this.filial === '') {
        document.getElementById('filial').classList.add('is-invalid');
      } else {
        document.getElementById('filial').classList.remove('is-invalid');
      }

      if (this.filial !== '') {
        const custom = document.querySelectorAll('.custom');
        const customInput = document.querySelectorAll('#customInput');
        const customLabel = document.querySelectorAll('#customLabel');

        for (let i = 0; i < custom.length; i += 1) {
          this.customField.push({
            key: customLabel[i].value,
            value: customInput[i].value,
          });
        }

        const newBranch = {
          data: {
            corporate_name: this.filial,
            description: this.description,
            group: this.group,
            code: this.code,
            secondary_fields: this.customField,
            type: 'ih1',
          },
          token: this.userAuth.token,
          companyId: this.userAuth.companyId,
        };

        try {
          await this.addBranch(newBranch);

          swal(
            this.$t('menu.settings.hierarchies.messages.succesAddBranch.title'),
            this.$t(
              'menu.settings.hierarchies.messages.succesAddBranch.description',
            ),
            'success',
          );

          await this.listBranchesIh1({
            companyId: this.userAuth.companyId,
            token: this.userAuth.token,
          });

          await this.getBranchesIH1({
            companyId: JSON.parse(localStorage.getItem('_indecx')).companyId,
            token: JSON.parse(localStorage.getItem('_indecx')).token,
            limit: 10,
            page: 1,
          });

          this.description = null;
          this.filial = '';
          this.code = null;
          this.group = null;
          this.customField = [];
          this.branches.splice(0);
        } catch (error) {
          swal('Oops!', `${error.response.data.message}`, 'warning');
        }
      }
    },

    async addGroup() {
      if (this.branches.length <= 4) {
        await this.branches.push('test');
      }
    },

    async removeGroup() {
      if (this.branches.length > 0) {
        await this.branches.pop('test');
      }
    },

    async removeBranch(branchId) {
      const obj = { branchId, token: this.userAuth.token };

      swal({
        title: this.$t('menu.settings.hierarchies.messages.removeBranch.title'),
        text: this.$t(
          'menu.settings.hierarchies.messages.removeBranch.description',
        ),
        icon: 'warning',
        buttons: [
          this.$t('menu.settings.hierarchies.buttonCancel'),
          this.$t('menu.settings.hierarchies.buttonRemove'),
        ],
        dangerMode: true,
      }).then(async (willDelete) => {
        if (willDelete) {
          await this.deleteBranch(obj);

          swal(this.$t('menu.settings.hierarchies.branchRemoved'), {
            icon: 'success',
          });

          await this.listBranchesIh1({
            companyId: this.userAuth.companyId,
            token: this.userAuth.token,
          });

          await this.getBranchesIH1({
            companyId: JSON.parse(localStorage.getItem('_indecx')).companyId,
            token: JSON.parse(localStorage.getItem('_indecx')).token,
            type: 'ih1',
            limit: 10,
            page: 1,
          });
        }
      });
    },
  },

  async created() {
    this.userAuth = JSON.parse(localStorage.getItem('_indecx'));

    this.handleBranches();

    this.fields = [
      {
        key: 'corporate_name',
        label: this.$t('menu.settings.hierarchies.labels.branch'),
      },
      {
        key: 'createdAt',
        label: this.$t('menu.settings.hierarchies.labels.creationDate'),
      },
      {
        key: 'options',
        label: this.$t('menu.settings.hierarchies.labels.options'),
      },
    ];
  },
};
</script>

<style lang="scss" scoped>
@import '@/themes/default/variables.scss';

.search-users {
  display: flex;
  flex-direction: row;

  input {
    border-bottom-right-radius: 0;
    border-top-right-radius: 0;
  }

  button {
    border-bottom-left-radius: 0;
    border-top-left-radius: 0;
  }
}

.header {
  color: #fff;
  background-color: #72bcd4;
}

.registerBranch {
  background: #fff;
  border: 1px solid #ccc;
  border-top: 0;
}

.btn-trash {
  position: relative;
  color: red;
  border: 1px solid red;
  &:hover {
    color: $white;
    background-color: red;
  }
  .mask {
    position: absolute;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
  }
}

.btn-add {
  color: $primary;
  border: 1px solid $primary;
  &:hover {
    color: $white;
    background-color: $primary;
  }
}

.btn-div {
  display: flex;
  justify-content: space-between;
}

.pagination-area-ih1 >>> a {
  position: relative;
  display: block;
  padding: 0.5rem 0.75rem;
  margin-left: -1px;
  line-height: 1.25;
  color: #4ce595;
  background-color: #fff;
  border: 1px solid #dee2e6;
}
</style>

<style>
.pagination-area-ih1 .active a {
  text-decoration: none;
  z-index: 1;
  color: #fff;
  background-color: #4ce595;
  border-color: #4ce595;
}

.pagination-area-ih1 a {
  outline: none;
}
</style>



// WEBPACK FOOTER //
// src/components/organisms/settings/branches/index.vue